/* eslint-disable @wyz/module/no-relative-import */
import { useState } from 'react';
import { Text, Title } from '@wyz/ui';
import { Trans } from '~/common/context';
import { ChangeLogsTable } from './change-logs-table';
import { ConnectionLogsTable } from './connection-logs-table';
import { LogType, LogTypeSwitcher } from './log-type-switcher';

const USER_COLLECTION = 'User';

export function UserLogsSection({ userId }: { userId: string }) {
  const [active, setActive] = useState<LogType>('modifications');

  const topSlot =
    active === 'connections' ? (
      <Text heading='xs' className='mb-3 text-muted'>
        <Trans i18nKey='app.logs.connections.retention_notice' />
      </Text>
    ) : undefined;

  return (
    <div className='mt-4'>
      <Title heading='page-title' weight='bold'>
        <Trans i18nKey='app.logs.history' />
      </Title>

      <LogTypeSwitcher active={active} onChange={setActive} />

      {active === 'modifications' ? (
        <ChangeLogsTable
          collection={USER_COLLECTION}
          documentId={userId}
          showTitle={false}
          showHeader={false}
          topSlot={topSlot}
        />
      ) : (
        <ConnectionLogsTable
          userId={userId}
          showTitle={false}
          topSlot={topSlot}
        />
      )}
    </div>
  );
}
